export default function logger() {

    function log(fn = null, message = null, type = null) {

        const logObj = {
            'c': btoa('Comp: ' + this.$options.name),
            'f': btoa('Fn: '+ fn),
            'm': message
        }
        switch (type) {
            case 'warn':
                this.$log.warn(logObj)
                break;
            case 'error':
                this.$log.error(logObj)
                break;
            default:
                this.$log.info(logObj)
                break;
        }

    }
    return {
        log
    }
}